/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AlignmentInputs */

const en_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignment`)
};

const es_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alineación`)
};

const fr_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alignement`)
};

const de_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausrichtung`)
};

const ja_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配置`)
};

const zh_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对齐方式`)
};

const ar_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المحاذاة`)
};

const id_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perataan`)
};

const it_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allineamento`)
};

const ru_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выравнивание`)
};

const pt_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alinhamento`)
};

const ko_alignment = /** @type {(inputs: AlignmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정렬`)
};

/**
* | output |
* | --- |
* | "Alignment" |
*
* @param {AlignmentInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const alignment = /** @type {((inputs?: AlignmentInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AlignmentInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_alignment(inputs)
	if (locale === "es") return es_alignment(inputs)
	if (locale === "fr") return fr_alignment(inputs)
	if (locale === "de") return de_alignment(inputs)
	if (locale === "ja") return ja_alignment(inputs)
	if (locale === "zh") return zh_alignment(inputs)
	if (locale === "ar") return ar_alignment(inputs)
	if (locale === "id") return id_alignment(inputs)
	if (locale === "it") return it_alignment(inputs)
	if (locale === "ru") return ru_alignment(inputs)
	if (locale === "pt") return pt_alignment(inputs)
	return ko_alignment(inputs)
});